import { Component, HostBinding, Input } from '@angular/core';
import { FileUploadStatus } from '../../uploader.interface';

@Component({
  selector: 'glxy-uploader-file-status',
  templateUrl: './uploader-file-status.component.html',
  styleUrls: ['./uploader-file-status.component.scss'],
  standalone: false,
})
export class GalaxyUploaderFileStatusComponent {
  @HostBinding('class') class = 'glxy-uploader-file-status';

  @Input() status?: FileUploadStatus;

  FileUploadStatus = FileUploadStatus;
}
